import { createContext } from "react";
import { ExtensionSettingsAccessor } from "../../State/EvidenceDB/DbExtensionSettings";
import { EvidenceDatabase } from "../../State/EvidenceDB/EvidenceDbStruct";
import { requireEvidenceDatabase } from "../../State/EvidenceDB/getDatabase";
import { LicenseCache } from "../../State/EvidenceDB/LicenseCache";
import { WorkerUrls } from "../../workers";



export interface GlobalContext extends WorkerUrls {
	readonly db: EvidenceDatabase;
	readonly extensionSettings: ExtensionSettingsAccessor;
	readonly licenseCache: LicenseCache;
}

export const createGlobalContext = async ({...workerUrls}: WorkerUrls) => {
	const [db, extensionSettings, licenseCache] = await Promise.all([
		requireEvidenceDatabase(),
		ExtensionSettingsAccessor.instance,
		LicenseCache.instancePromise,
	]);
	const globalContext: GlobalContext = {
		...workerUrls,
		db,
		extensionSettings,
		licenseCache,
	}
	return globalContext;
}

export const GlobalContext = createContext<GlobalContext | undefined>(undefined);
